export const filterControlsEnglish = {
  any: "Any",
  minutes: "Minutes",
  minimum: "Minimum",
  maximum: "Maximum",
  invalid_range: "Enter a valid range: minimum must not exceed maximum.",
  observed: "Observed range: {{range}}",
  reset: "Reset range",
  remove: "Remove {{filter}} filter",
  people_count: "People count",
  visibility: "Visibility",
  archive_hint: "Archived sessions are excluded from the overview and process reporting.",
};

export const filterControlsItalian = {
  any: "Qualsiasi",
  minutes: "Minuti",
  minimum: "Minimo",
  maximum: "Massimo",
  invalid_range: "Inserisci un intervallo valido: il minimo non deve superare il massimo.",
  observed: "Intervallo osservato: {{range}}",
  reset: "Reimposta intervallo",
  remove: "Rimuovi filtro {{filter}}",
  people_count: "Numero di persone",
  visibility: "Visibilità",
  archive_hint: "Le sessioni archiviate sono escluse dalla panoramica e dai report sui processi.",
};

export const filterControlsGerman = {
  any: "Beliebig",
  minutes: "Minuten",
  minimum: "Minimum",
  maximum: "Maximum",
  invalid_range:
    "Gib einen gültigen Bereich ein: Das Minimum darf das Maximum nicht überschreiten.",
  observed: "Beobachteter Bereich: {{range}}",
  reset: "Bereich zurücksetzen",
  remove: "Filter {{filter}} entfernen",
  people_count: "Personenanzahl",
  visibility: "Sichtbarkeit",
  archive_hint:
    "Archivierte Sitzungen sind von der Übersicht und den Prozessberichten ausgeschlossen.",
};
